import React, { FC, ReactNode } from 'react';

import { Text } from '../Text';
import { Link, LinkProps } from '../Link';

export interface BreadcrumbItemProps extends Pick<LinkProps, 'href' | 'onClick' | 'target' | 'routerOptions'> {
    text: ReactNode;
}

export interface BreadcrumbsProps {
    /** Размер текста в элементах
     *  @default s
     */
    size?: 's' | 'xs';

    /** Список пропсов элементов */
    list: BreadcrumbItemProps[];

    /** Дополнительный класс, добавляемый к корневому элементу */
    className?: string;
}

export const Breadcrumbs: FC<BreadcrumbsProps> = function Breadcrumbs(props) {
    const { size = 's', list, className } = props;

    if (!list.length) {
        return null;
    }

    return (
        <Text size={size} color="current" role="supplementary" className={className}>
            {list.map(({ text, ...linkProps }, index) => (
                <React.Fragment key={index}>
                    {index !== 0 && '・'}
                    {isLink(linkProps) ? (
                        <Link {...linkProps} color={'supplementary'}>
                            {text}
                        </Link>
                    ) : (
                        text
                    )}
                </React.Fragment>
            ))}
        </Text>
    );
};

const isLink = (itemProps: LinkProps): boolean => {
    return Boolean(itemProps.href || itemProps.onClick);
};
